import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import calcAge from "@/lib/calcAge";
import config from "@/lib/config";
import { userRating } from "@/lib/constants";
import { myListFavoritesSort, myListWatchHistorySort } from "@/lib/sorts";
import { randomBytes } from "crypto";
import { v4 as uuidv4 } from "uuid";
import LogicaAPI from "./logicaapi";
class User extends LogicaAPI {
  async login(loginId, password) {
    return await this.post("/api/v1/users/spod_auth", {
      body: {
        mail_address: loginId,
        password: password
      }
    });
  }
  me() {
    return this.get("/api/v1/users/me", {
      params: {
        ts: +new Date(),
        with_profiles: true
      }
    });
  }
  logout() {
    return this.post("/api/v1/users/logout", {
      body: {
        with_all_device: false,
        with_profiles: false
      }
    });
  }
  async signup(_ref) {
    let {
      mailAddress,
      password,
      firstName,
      lastName,
      birthday,
      sex
    } = _ref;
    let extraInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const age = calcAge(birthday);
    const rating = Object.keys(userRating).filter(key => userRating[key].enableAge <= age).reduce((a, b) => Math.min(a, b));
    const uuid = uuidv4();

    // console.log("email: ", mailAddress);
    console.log("unique_id: ", uuid);
    return await this.post("/api/v1/users/regist", {
      body: {
        unique_id: uuid,
        schema_id: 1,
        mail_address: mailAddress,
        password,
        first_name: firstName,
        last_name: lastName,
        display_name: `${lastName} ${firstName}`,
        birthday,
        sex,
        values: _objectSpread({
          service: config.service,
          icon: 1,
          rating
        }, extraInfo)
      }
    });
  }
  favorites(_ref2) {
    let {
      offset = 0,
      limit = 50
    } = _ref2;
    const params = {
      user_id: this.config.profileId || this.config.userId,
      model_type: "meta",
      app_id: this.config.appId,
      device_code: this.config.deviceCode,
      datasource: "decorator",
      with_total_count: true,
      from: offset,
      limit
    };
    return this.get("/api/v1/users/favorites", {
      params
    });
  }
  favoritesByMetaSchemaId(_ref3) {
    let {
      offset,
      limit,
      metaSchemaId
    } = _ref3;
    const sort = myListFavoritesSort.sort;
    const order = myListFavoritesSort.value;
    const params = {
      user_id: this.config.profileId || this.config.userId,
      model_type: "meta",
      app_id: this.config.appId,
      device_code: this.config.deviceCode,
      datasource: "decorator",
      with_total_count: true,
      from: offset,
      limit,
      sort: sort,
      order: order
    };
    if (metaSchemaId) {
      params["meta_schema_id"] = metaSchemaId;
    }
    return this.get("/api/v1/users/favorites", {
      params
    });
  }
  async allFavorites(_ref4) {
    let {
      offset,
      limit
    } = _ref4;
    let favoriteMetas = [];
    if (this.isMaybeLoggedIn()) {
      const get = async offset => {
        const res = await this.favorites({
          offset,
          limit
        });
        const metas = res.user_favorites.map(fav => fav.meta);
        favoriteMetas = [...favoriteMetas, ...metas];
        if (res.total_count > favoriteMetas.length) {
          await get(offset + limit);
        }
      };
      await get(offset);
    }
    return favoriteMetas;
  }
  addFavorite(id) {
    const params = {
      user_id: this.config.profileId || this.config.userId,
      model_type: "meta",
      model_id: id
    };
    return this.post("/api/v1/users/favorites/add", {
      body: params
    });
  }
  deleteFavorite(id) {
    const params = {
      user_id: this.config.profileId || this.config.userId,
      model_type: "meta",
      model_id: id
    };
    return this.post("/api/v1/users/favorites/delete", {
      body: params
    });
  }
  addViewingHistory(_ref5) {
    let {
      resume,
      metaId,
      groupedMetaId,
      psid,
      reachToEnd
    } = _ref5;
    const params = {
      user_id: this.config.profileId || this.config.userId,
      meta_id: metaId,
      psid: psid,
      device_code: this.config.deviceCode,
      app_id: this.config.appId,
      resume_point: resume,
      reach_to_end_flag: reachToEnd,
      grouped_meta_id: groupedMetaId
    };
    // デバイス登録が有効な場合、viewing_device_idもパラメータにいれる
    return this.post("/api/v1/users/viewing_histories/add", {
      body: params
    });
  }
  getViewingHistory(args) {
    const sortOrder = myListWatchHistorySort.find(v => v.value == args.sort);
    const params = {
      user_id: this.config.profileId || this.config.userId,
      device_code: this.config.deviceCode,
      app_id: this.config.appId,
      datasource: "decorator",
      reach_to_end_flag: false,
      from: args.offset,
      limit: args.limit,
      sort: sortOrder.sort,
      order: sortOrder.value,
      with_total_count: true,
      is_delivering: true
    };
    // 本番のCFが60秒キャッシュされるので、回避のためにパラメーターを追加する
    if (args.nocache) {
      params.ts = +new Date();
    }
    // デバイス登録が有効な場合、viewing_device_idもパラメータにいれる
    return this.get("/api/v1/users/viewing_histories", {
      params
    });
  }
  deleteViewingHistory(metaIds) {
    // metaIds string メタID、複数指定の場合はカンマ区切り
    const params = {
      user_id: this.config.profileId || this.config.userId,
      meta_id: metaIds
    };
    // デバイス登録が有効な場合、viewing_device_idもパラメータにいれる
    return this.post("/api/v1/users/viewing_histories/delete", {
      body: params
    });
  }
  addViewingBookmark(_ref6) {
    let {
      resume,
      metaId,
      groupedMetaId
    } = _ref6;
    if (!groupedMetaId) return null;
    const params = {
      user_id: this.config.profileId || this.config.userId,
      meta_id: groupedMetaId,
      bookmark_meta_id: metaId,
      position: resume
    };
    return this.post("/api/v1/users/viewing_bookmarks/add", {
      body: params
    });
  }
  entitlementsFromMeta(meta_id) {
    if (this.context.req.userToken) {
      const params = {
        meta_id,
        user_id: this.config.userId,
        ts: +new Date()
      };
      return this.get("/api/v1/users/entitlements", {
        params
      });
    } else {
      return {
        entitlements: []
      };
    }
  }
  async entitlementsFromRight(rightIds) {
    if (this.context.req.userToken) {
      const params = {
        right_id: rightIds.join(","),
        user_id: this.config.userId,
        ts: +new Date()
      };
      return this.get("/api/v1/users/entitlements", {
        params
      });
    } else {
      return {
        entitlements: []
      };
    }
  }
  // APIの設計として、mailaddressはrequest parameterから取得するため、bodyには入れない
  async update(args) {
    const params = {
      mail_address: args.mailAddress
    };
    return this.patch("/api/v1/users", {
      params
    });
  }
  updateValues(values) {
    return this.patch("/api/v1/users", {
      body: {
        values
      }
    });
  }
  async updatePassword(password) {
    return this.patch("/api/v1/users", {
      body: {
        password
      }
    });
  }
  async updateOwnerProfile(_ref7) {
    let {
      displayName,
      icon,
      passcode,
      rating
    } = _ref7;
    const params = {
      display_name: displayName,
      values: {
        rating: rating
      }
    };
    if (icon != null) {
      params.values.icon = icon;
    }
    if (passcode != null) {
      params.values.passcode = passcode;
    }
    return this.patch("/api/v1/users", {
      body: params
    });
  }
  async addProfile(args) {
    // LogicaAPIではパスワードはオプショナルだが、モデルのバリデートでエラーになるので
    // ダミーのパスワードをいれるしかない
    const dummyPassword = randomBytes(12).toString("hex");
    const params = {
      display_name: args.displayName,
      sex: args.sex,
      password: dummyPassword,
      birthday: args.birthday,
      schema_id: 2,
      values: {
        icon: args.icon,
        rating: args.rating,
        passcode: args.passcode
      }
    };
    return this.post("/api/v1/profiles/add", {
      body: params
    });
  }
  async updateProfile(_ref8) {
    let {
      displayName,
      sex,
      birthday,
      profileId,
      icon,
      rating,
      passcode
    } = _ref8;
    const params = {
      display_name: displayName,
      sex: sex,
      birthday: birthday,
      profile_id: profileId,
      schema_id: 2,
      values: {
        icon: icon,
        rating: rating
      }
    };
    if (passcode != null) {
      params.values.passcode = passcode;
    }
    return this.post("/api/v1/profiles/update", {
      body: params
    });
  }
  async deleteProfile(args) {
    const params = {
      profile_id: args.profileId
    };
    return this.post("/api/v1/profiles/delete", {
      body: params
    });
  }
  async entitlements() {
    return this.get("/api/v1/users/entitlements");
  }
  async rightIds() {
    const res = await this.entitlements();
    return res.entitlements.map(entitle => entitle.right_id);
  }
  async withdrawal() {
    return this.get("/api/v1/users/withdrawal");
  }
  async viewingBookmarkFromMeta(metaId) {
    if (this.isMaybeLoggedIn()) {
      var _res$viewing_bookmark;
      const params = {
        user_id: this.config.profileId || this.config.userId,
        meta_id: metaId,
        with_bookmark_meta: true,
        datasource: "decorator",
        ts: +new Date()
      };
      const res = await this.get("/api/v1/users/viewing_bookmarks", {
        params
      });
      return res === null || res === void 0 || (_res$viewing_bookmark = res.viewing_bookmarks) === null || _res$viewing_bookmark === void 0 ? void 0 : _res$viewing_bookmark[0];
    } else {
      return null;
    }
  }
  async userOrders(args) {
    if (!args.year) {
      args.year = new Date().getFullYear();
    }
    const params = {
      from: args.offset,
      limit: args.limit,
      adult_flag: false,
      created_at_from: args.year + "-01-01",
      created_at_to: args.year + "-12-31"
    };
    return this.post("/api/v1/users/orders", {
      body: params
    });
  }
  checkPassword(password) {
    if (this.isMaybeLoggedIn()) {
      return this.post("/api/v1/users/auth/check_password", {
        body: {
          password
        }
      });
    } else {
      return {
        result: false
      };
    }
  }
  async broadcastDiscount(args) {
    const params = {};
    if (!!args.productId) {
      params.product_id = args.productId;
    }
    if (!!args.courseId) {
      params.course_id = args.courseId;
    }
    return this.get("/api/v1/users/broadcast_discount", {
      params
    });
  }
  async existed(mailAddress) {
    const res = await this.post("/api/v1/users/existed", {
      body: {
        mail_address: mailAddress
      }
    });
    if (res !== null && res !== void 0 && res.result) {
      return {
        id: res === null || res === void 0 ? void 0 : res.user_id
      };
    } else {
      return null;
    }
  }
  async passwordUpdate(_ref9) {
    let {
      userId,
      password
    } = _ref9;
    return this.patch("/api/v1/users/password_update", {
      body: {
        user_id: userId,
        password
      }
    });
  }
  async voucher(userVoucherId) {
    var _res$user_voucher;
    const res = await this.get(`/api/v1/users/vouchers/${userVoucherId}/simulate`);
    return res === null || res === void 0 || (_res$user_voucher = res.user_voucher) === null || _res$user_voucher === void 0 ? void 0 : _res$user_voucher.voucher;
  }
  async advertisingPreferences(_ref10) {
    let {
      receiveAdvertisingMailFlag
    } = _ref10;
    const params = {
      receive_advertising_mail_flag: receiveAdvertisingMailFlag,
      adult_flag: false
    };
    return await this.patch("/api/v1/users/advertising_preferences", {
      params
    });
  }
}
export default User;